module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    directives: [{
      name: "lang",
      rawName: "v-lang.need_help",
      modifiers: {
        "need_help": true
      }
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "help"
  }, [_c('span', {
    directives: [{
      name: "lang",
      rawName: "v-lang.need_help_secondary",
      modifiers: {
        "need_help_secondary": true
      }
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:18475555555"
    }
  }, [_vm._v(" " + _vm._s(_vm.phone) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('i', {
    staticClass: "fa  fa-envelope-o "
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.mailto
    }
  }, [_vm._v(_vm._s(_vm.email))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "lang",
      rawName: "v-lang.or_use",
      modifiers: {
        "or_use": true
      }
    }]
  }), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "lang",
      rawName: "v-lang.contact_form",
      modifiers: {
        "contact_form": true
      }
    }],
    attrs: {
      "to": "/site/contact"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f8a01da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/singleRoom/widgets/help.vue
// module id = 352
// module chunks = 0